<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 09:39:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-07 15:22:24
 * @name: 待审批
 * @Description: 待审批
 * @FilePath: \project\src\views\index\afterSaleWaitApprove\afterSaleWaitApproveRouter.vue
 * @Author: desktop
-->
<template>
  <div class="afterSaleWaitApproveRouter">
    <keep-alive :include="cashRouters">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "indexAfterSaleWaitApprove",
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    },
  },
};
</script>
<style lang="scss" scoped>
.afterSaleWaitApproveRouter {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>